const Sales188Dashboard = () => {
  return <div>Sales188Dashboard</div>;
};

export default Sales188Dashboard;
